import { useQuery } from '@tanstack/react-query'
import { getCreditBalance } from '../services/api.js'

export const useCredits = (enabled = true) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['credits'],
    queryFn: getCreditBalance,
    staleTime: 5000,
    enabled,
  })

  const credits = data?.credits ?? data?.balance ?? 0

  return { credits, isLoading, isError }
}
